import React from "react";
import styled from "styled-components";
import { Form, Field } from "react-final-form";
import { Calendar } from 'primereact/calendar';
import moment from "moment";
import CalendarIcon from "assets/calendar.svg";

interface CustomDateRangeProps {
    selectedData: string;
    formRef: React.MutableRefObject<any>;
    onSubmit: (values: any) => void;
    onDatesChange: (isValid: boolean) => void;
}

const PLACEHOLDER_TEXT = "Select a period";

const CustomDateRange: React.FC<CustomDateRangeProps> = ({ selectedData, formRef, onSubmit, onDatesChange }) => {

    const isCustomRange = (data: string): boolean => {
        return data !== PLACEHOLDER_TEXT &&
            data.includes("-") &&
            !data.includes("days") &&
            !data.includes("week") &&
            !data.includes("month") &&
            !data.includes("year");
    };

    const getInitialValues = () => {
        if (!isCustomRange(selectedData)) {
            return { from: null, to: null };
        }

        const [fromStr, toStr] = selectedData.split(" - ");
        return {
            from: moment(fromStr, 'YYYY-MM-DD').toDate(),
            to: moment(toStr, 'YYYY-MM-DD').toDate()
        };
    };

    return (
        <FormBox>
            <Form
                onSubmit={onSubmit}
                initialValues={getInitialValues()}
                render={({ handleSubmit, values }) => {
                    formRef.current = handleSubmit;

                    React.useEffect(() => {
                        const isValid = values.from && values.to;
                        onDatesChange(!!isValid);
                    }, [values.from, values.to]);

                    return (
                        <form onSubmit={handleSubmit}>
                            <DateFieldWrapper>
                                <Field
                                    name="from"
                                    render={({ input }) => (
                                        <StyledCalendar
                                            value={input.value || null}
                                            onChange={(e) => input.onChange(e.value)}
                                            showIcon
                                            icon={<CalendarIcon />}
                                            placeholder="Date from"
                                            maxDate={values.to || undefined}
                                        />
                                    )}
                                />
                            </DateFieldWrapper>
                            <DateFieldWrapper>
                                <Field
                                    name="to"
                                    render={({ input }) => (
                                        <StyledCalendar
                                            value={input.value || null}
                                            onChange={(e) => input.onChange(e.value)}
                                            showIcon
                                            icon={<CalendarIcon />}
                                            placeholder="Date to"
                                            minDate={values.from || undefined}
                                        />
                                    )}
                                />
                            </DateFieldWrapper>
                        </form>
                    );
                }}
            />
        </FormBox>
    );
};

export default CustomDateRange;

const FormBox = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const DateFieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const StyledCalendar = styled(Calendar)`
    border: 1px solid #E9E9E9;
    border-radius: 8px;
    width: 100%;

    .p-datepicker-trigger {
        background-color: transparent;
        border: none;

        &:hover {
            background-color: rgba(103, 119, 255, 0.1);
        }

        &:focus {
            box-shadow: none;
        }
    }

    .p-inputtext {
        font-size: 13px;
        font-weight: 500;
        padding: 8px 12px;
        border: none;
        box-shadow: none !important;
    }
`;
